import { useState } from 'react';
import { get, has } from 'lodash';
import { ajaxExceptionMessage } from '@skunexus/utils';

const EXAMPLE_CSV = [
    [
        'sku',
        'name',
        'weight',
        'description',
        'barcode_type',
        'barcode_value',
        'custom_field_price',
        'custom_field_is_standalone_product',
        'custom_field_parent_master',
        'custom_field_style_code',
        'custom_field_color_code',
        'custom_field_condition',
        'custom_field_size',
        'custom_field_color_group',
    ],
    [
        'XDD-003-S',
        'Name XDD-003-S',
        '0',
        'XDD-003-S Descr',
        'CODE128',
        'XDD-003-Sbar',
        '30',
        '0',
        '0',
        'XDD',
        '003',
        'Like New',
        'S',
        '',
    ],
    ['ABC', 'Name ABCC', '0', 'Test, Test', 'CODE128', 'ABC-CBA1', '20', '1', '0', 'ABC', '002', 'Like New', 'XL', ''],
    ['DXL', 'Name DXL', '0', 'TestXX', 'CODE128', 'ABC-CBA1', '20', '0', '1', 'DXL', '', '', '', ''],
    [
        'DXL-001-L',
        'Name DXL-001-L',
        '0',
        'DXL-001-L Descr',
        'CODE128',
        'DXL-001-Lbar',
        '50',
        '0',
        '0',
        'DXL',
        '001',
        'Like New',
        'L',
        '',
    ],
    ['XDD', 'Name XDD', '0', 'TestXX XDD', 'CODE128', 'XDD', '20', '0', '1', '', '', '', '', ''],
    [
        'GJ-K-APB1',
        'General | Jordan | Kids | Apparel Bottom  Base Layer',
        0,
        'Standard release product | Jordan Brand description',
        'CODE128',
        'GJ-K-APB1',
        24,
        1,
        0,
        'APB1',
        'GJ',
        'Like New',
        'K',
        'Black',
    ],
];

export function useProductImport({ mutation, errorNotification, successNotification }) {
    const [isImportModalOpen, toggleImportModal] = useState(false);
    const [isPending, setIsPending] = useState(false);

    const handleImport = async (acceptedFiles) => {
        setIsPending(true);
        try {
            const result = await mutation({ file: acceptedFiles[0] });

            if (has(result, 'data.errors')) {
                throw new Error('Error occurs in graphql');
            }

            successNotification('Products imported successfully.');
            toggleImportModal((prev) => !prev);
        } catch (error) {
            errorNotification(ajaxExceptionMessage(error));
        } finally {
            setIsPending(false);
        }
    };

    return [
        {
            importModalProps: {
                modalProps: {
                    headerLabel: 'Import Products',
                    isOpen: isImportModalOpen,
                    isLoading: isPending,
                },
                exampleFile: EXAMPLE_CSV,
                onClose: () => toggleImportModal((prev) => !prev),
                onConfirm: handleImport,
            },
        },
        { handleOpenImportModal: () => toggleImportModal((prev) => !prev) },
    ];
}
